import { useTranslation } from "react-i18next";
import { useConnectivity } from "@/hooks/useConnectivity";

export const ConnectivityGuard = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const { t } = useTranslation();
  const online = useConnectivity();
  return (
    <>
      {!online && (
        <div
          className="fixed top-0 inset-x-0 z-40 bg-primary-deep text-white text-center text-sm py-2 pt-safe animate-slide-down"
          role="status"
        >
          {t("offline.banner", "Pas de connexion — l'envoi est désactivé")}
        </div>
      )}
      {children}
    </>
  );
};
